import { Component, Inject, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatSnackBar } from '@angular/material/snack-bar';
import { BackendApi } from '../../services/backend-api';
import { Zone } from '../../models/zone';
import { Package, PackageZoneCreate } from '../../models/package';

@Component({
  selector: 'app-create-package-zone-dialog',
  imports: [MatDialogModule, MatInputModule, MatButtonModule, MatFormFieldModule, ReactiveFormsModule, MatSelectModule],
  templateUrl: './create-package-zone-dialog.html',
  styleUrl: './create-package-zone-dialog.css',
})
export class CreatePackageZoneDialog {
  constructor(
    private readonly backendApi: BackendApi,
    private dialogRef: MatDialogRef<CreatePackageZoneDialog>,
    @Inject(MAT_DIALOG_DATA) public thePackage: Package
  ) { }

  private _snackBar = inject(MatSnackBar);
  private _formBuilder = inject(FormBuilder);

  public zones!: Zone[];

  packageZoneForm = this._formBuilder.group({
    zone: ['', Validators.required]
  });

  ngOnInit() {
    this.backendApi.getZones().subscribe({
      next: (zones) => {
        this.zones = zones;
      },
      error: () => {
        this._snackBar.open("Erreur rencontrée lors de la recuperation des zones.");
      }
    });
  }

  submit() {
    const packageZone: PackageZoneCreate = this.packageZoneForm.value as PackageZoneCreate;

    this.backendApi.createPackageZone(this.thePackage.uuid, packageZone).subscribe({
      next: (response) => {
        this._snackBar.open("Entrée ajoutée.");
        this.dialogRef.close(response);
      },
      error: () => {
        this._snackBar.open("Erreur rencontrée.");
      }
    })
  }
}
